import React, { PureComponent } from "react";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import { pi1LegalProcTextUpdates } from "./services/pi1-form-content";

class AcctLegalNotice extends PureComponent {
  render() {
    return (
      <Row className="pf-registration-legal-notice">
        <Col width={{ sm: 12, lg: 12 }}>
          {pi1LegalProcTextUpdates.map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </Col>
      </Row>
    );
  }
}

export default AcctLegalNotice;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');